import script from "./FundraiserDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./FundraiserDetails.vue?vue&type=script&setup=true&lang=js"

import "./FundraiserDetails.vue?vue&type=style&index=0&id=12d9440e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12d9440e"]])

export default __exports__